import React, { useEffect, useState } from 'react';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import { devLogin, getAuthConfig, getMe, logout } from '../services/api';

const AuthGate = () => {
  const [ready, setReady] = useState(false);
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState({ googleConfigured: false, devBypass: false });

  const refresh = async () => {
    try {
      const cfg = await getAuthConfig();
      setConfig(cfg);
      try {
        setUser(await getMe());
      } catch {
        setUser(null);
      }
    } catch {
      setConfig({ googleConfigured: false, devBypass: false });
      setUser(null);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  if (!ready) {
    return <div className="min-h-screen bg-[#07080d]" />;
  }

  if (!user) {
    return (
      <LoginPage
        config={config}
        onDevLogin={async () => {
          await devLogin();
          await refresh();
        }}
      />
    );
  }

  return (
    <DashboardPage
      email={user.email}
      onLogout={async () => {
        await logout();
        setUser(null);
      }}
    />
  );
};

export default AuthGate;
